
import { LoadProfile } from '../../Services/ProfileServices';
import * as ActionTypes from '../ActionTypes';


export const LoadProfileAction = () => {
    return async (dispatch) => {
        const tokenName = process.env.REACT_APP_BACKEND_TOKEN_NAME || 'user-token';
        const token = localStorage.getItem(tokenName);
        if (!token) {
            return;
        }

        dispatch({ type: ActionTypes.LOADING_PROFILE });
        LoadProfile().then((res) => {
            if (res.hasOwnProperty('success') && res.success === true) {
                dispatch({ type: ActionTypes.LOAD_PROFILE_SUCCESS, res });
            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.LOAD_PROFILE_ERROR, res });
            }
        }).catch((error) => {
            var error_message = error.message;
            dispatch({ type: ActionTypes.CODE_ERROR, error_message });
        });
    }
}

